import sessionStore from '~/stores/SessionStore';
import random from '~/utils/random';

class ModalStack {
  stack = [];

  get stackLength() {
    return this.stack.length;
  }

  push = (closeFunc) => {
    if (typeof closeFunc === 'function' && sessionStore.isMobile) {
      const key = random.float()
        .toString(32)
        .substr(2);
      const path = window.location.href.split(window.location.origin)[1];
      this.stack.push({
        fun: closeFunc,
        path,
        key
      });
      window.history.pushState({}, '', `/modal/${key}`);
    }
  };

  pop = () => {
    if (this.stackLength) {
      const {path} = this.stack.pop();
      window.history.replaceState({}, '', path);
    }
  };

  clear = () => {
    (this.stack || [])
      .slice()
      .reverse()
      .forEach(({fun}) => fun());
    this.stack = [];
  };
}

const instance = new ModalStack();

export function createModalHistoryHandler(action, callback) {
  const length = instance.stackLength;
  if (action === 'POP' && length > 0) {
    instance.stack[length - 1].fun();
    callback(false);
  } else {
    instance.clear();
    callback(true);
  }
}

export default {
  pushStack: instance.push,
  popStack: instance.pop,
  clearStack: instance.clear
};
